import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Klickbar LagbasN-logotyp — navigerar alltid till landingssidan (/).
 * Används i sidors mörka header-rad.
 */
export default function LagbasLogo({ size = '1.4rem' }) {
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => navigate('/')}
      sx={{
        cursor: 'pointer',
        userSelect: 'none',
        flexShrink: 0,
        '&:hover': { opacity: 0.85 },
        transition: 'opacity .15s',
      }}
    >
      <Typography fontWeight={900} sx={{
        fontSize: size,
        color: 'white',
        letterSpacing: '-0.5px',
        fontFamily: '"Segoe UI", "Roboto", "Arial", sans-serif',
        lineHeight: 1,
      }}>
        Lagbas<Box component="span" sx={{ color: '#FF6B00' }}>N</Box>
      </Typography>
    </Box>
  );
}
